export const ADMIN_TOKEN = 'token'
export const END_USER_TOKEN = 'endUserToken'
export const REPORT_ACCESS_TOKEN = 'reportAccessToken'

export const ADMIN_SESSION_MGR_CHANNEL_ID = 'usecure_admin_session_manager'
